import axios from "../axios.config";
import Swal from "sweetalert2";

const state = {
  token: [],
};

const actions = {
  async loadToken({ commit }) {
    try {
      const { data } = await axios.get("/token-api/");
      if (!data.success) {
        throw new Error(data.message);
      }
      commit("SET_TOKEN", data.data);
    } catch (error) {
      throw new Error(error);
    }
  },

  async newToken({ commit }) {
    try {
      const { data } = await axios.put(`/token-api/update`);
      if (!data.success) {
        throw new Error(data.message);
      }
    } catch (error) {
      throw new Error(error);
    }
  },
};

const mutations = {
  SET_TOKEN: (state, data) => {
    state.token = data;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
